import {useDispatch, useSelector} from 'react-redux';
import {UPDATE_DESIGN_OPTIONS} from '~/CreateFabricGreetingCard/reducers/fabricDesign/constants';
import {
  selectCurrentSection,
  selectIgnorePremiumWarning,
  selectLoaded,
} from '~/CreateFabricGreetingCard/reducers/fabricDesign/selectors';
import {Sections} from '~/common/FabricInvitation/EventCreateDesign/constants';
import {useNavigator} from '~/common/fabric/CreateDesign/components/NavBottom/useNavigator';
import {Button} from '~library/atoms/Button';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {largishAndUp} from '~libSass/base/_exports.sass';
import './NavButton.sass';

export const NavButton = ({title, icon, section, disableAutoOpenEditor, highLight = false}) => {
  const currentSection = useSelector(selectCurrentSection);
  const loaded = useSelector(selectLoaded);
  const {matches: isDesktop} = useMatchQuery(`(min-width: ${largishAndUp})`);
  const isMobile = !isDesktop;
  const navigate = useNavigator({isMobile, disableAutoOpenEditor});
  const dispatch = useDispatch();
  const ignorePremiumWarning = useSelector(selectIgnorePremiumWarning);

  const onClickHandler = () => {
    if (section !== Sections.CARD_DESIGN && !ignorePremiumWarning) {
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {
          premiumFeaturesWarning: false,
          ignorePremiumWarning: true,
        },
      });
    }
    navigate(section);
  };

  return (
    <div
      tabIndex={-1}
      onKeyUp={null}
      className={`create_flow__nav_bottom__section ${
        currentSection === section ? 'create_flow__nav_bottom__section--active' : ''
      }`}
      onClick={onClickHandler}
      role="button"
    >
      <Button
        id="navBottom"
        className={`create_flow__nav_bottom__section__button ${
          highLight && 'create_flow__nav_bottom__section__button--highlighted'
        }`}
        variant="transparent"
        size="medium"
        disabled={!loaded}
        data-qa-id={`nav-bottom-${section}`}
      >
        {icon}
      </Button>
      <p className="create_flow__nav_bottom__section__title">{title}</p>
    </div>
  );
};
